export enum NavItem {
  home = 'home',
  shop = 'shop',
  offer = 'offer',
  projects = 'projects'
}
